<script>
    import { fade, fly } from "svelte/transition";
    import { cubicOut, cubicIn, sineOut } from "svelte/easing";
    import { factoryStore } from "../store/factories.js";
    import { langTextStore } from "../store/langtexts.js";
    import { getContext } from "svelte";
    import TitleWithHelp from "../SharedComponents/TitleWithHelp.svelte";
    const { snackbar } = getContext("app");
    const { close } = getContext("modal");

    $factoryStore.currentCalculator.sheetNums = [];
    let isPdfOrExcel = "pdfwith";

    var sheets = [];
    function getSheetNames() {
        var sheetList = "Sheet 1,Sheet 2,Sheet 3";
        if (
            $factoryStore.currentCalculator.excelSheetNames &&
            $factoryStore.currentCalculator.excelSheetNames.length > 0
        ) {
            sheetList = $factoryStore.currentCalculator.excelSheetNames;
        }
        var sheetNames = sheetList.split(",");
        for (var sheetNum in sheetNames) {
            sheets.push({
                id: parseInt(sheetNum) + 1,
                name: sheetNames[sheetNum],
                cleanName: sheetNames[sheetNum].replace("pdfonly ", ""),
                // .replace("notargetwage", "")
                // .replace("targetwage", ""),
            });
        }
    }
    $: includeTargetWage = isPdfOrExcel == "pdfwith" ? true : false;

    $: filteredSheets = sheets.filter(
        (s) =>
            (includeTargetWage && !s.name.includes("notargetwage")) ||
            (!includeTargetWage && !s.name.includes(" targetwage"))
    );
    getSheetNames();
    let loading = false;
    $langTextStore.getText("general-label-generating");
</script>

{#if loading}
    <h1>{$langTextStore.getText("general-label-generating")}</h1>
{:else}
    <h1>{$langTextStore.getText("general-label-choose-pdf-or-excel")}</h1>
    <input
        type="radio"
        value="pdfwithout"
        id="pdfwithout"
        on:change={() => {
            $factoryStore.currentCalculator.sheetNum = null;
        }}
        bind:group={isPdfOrExcel}
    /><label for="pdfwithout"
        ><TitleWithHelp
            variable={{
                nameKey: "pdf_without_target_wage",
            }}
        /></label
    ><br />
    <input
        type="radio"
        value="pdfwith"
        id="pdfwith"
        on:change={() => {
            $factoryStore.currentCalculator.sheetNum = null;
        }}
        bind:group={isPdfOrExcel}
    /><label for="pdfwith"
        ><TitleWithHelp
            variable={{
                nameKey: "pdf_with_target_wage",
            }}
        /></label
    ><br />
    <input
        type="radio"
        value="excel"
        id="excel"
        bind:group={isPdfOrExcel}
    /><label for="excel"
        ><TitleWithHelp
            variable={{
                nameKey: "excel",
            }}
        /></label
    >
    {#if isPdfOrExcel == "excel"}
        <br /><button
            class="btn btn-primary mt-4 mb-4 px-4 w-auto float-start"
            on:click={async () => {
                loading = true;
                await factoryStore.generateExcel(
                    $factoryStore.currentCalculator
                );
                close();
                loading = false;
            }}
            >{$langTextStore.getText("general-label-create-report")}
        </button>
    {/if}

    <div id="pdf_fields" class:vis-hidden={isPdfOrExcel == "excel"}>
        <h2>{$langTextStore.getText("general-label-choose-sheets")}</h2>
        <!-- <select bind:value={$factoryStore.currentCalculator.sheetNum}>
            <option id="empty" value={null}
                >{$langTextStore.getText("choose")}</option
            > -->
        {#each filteredSheets as sheet}
            <input
                type="radio"
                bind:group={$factoryStore.currentCalculator.sheetNum}
                id="sheet{sheet.id}"
                value={sheet.id}
            /><label for="sheet{sheet.id}"
                ><TitleWithHelp
                    variable={{
                        nameKey: sheet.cleanName.replace(" ", "_"),
                    }}
                /></label
            ><br />
        {/each}
        <!-- </select> -->
        <button
            class="btn btn-primary mt-4 mb-4 px-4 w-auto float-start"
            on:click={async () => {
                if ($factoryStore.currentCalculator.sheetNum == null) {
                    snackbar(
                        "info",
                        $langTextStore.getText("general-warning-choose-report")
                    );
                    return false;
                }
                $factoryStore.currentCalculator.sheetNums = [
                    $factoryStore.currentCalculator.sheetNum,
                ];
                loading = true;
                await factoryStore.generatePdf($factoryStore.currentCalculator);
                close();
                loading = false;
            }}
            >Create Report
        </button>
    </div>
{/if}

<style>
    .vis-hidden {
        visibility: hidden;
    }
    label {
        display: inline;
    }
</style>
